module.exports = __webpack_public_path__ + "img/RUS-flag.9832dd5c.png";